import React, { useState } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { NavLink } from "react-router-dom";
import { logotext } from "../content_option";
import Themetoggle from "../components/themetoggle";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/contact", label: "Contact" },
];

const Headermain = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const close = () => setMobileOpen(false);

  return (
    <>
      <header className="fixed-top site__header">
        <div className="header__inner">
          <NavLink className="nav__logo" to="/" onClick={close}>
            {logotext}
          </NavLink>

          <nav className="nav__links" aria-label="Main navigation">
            {navItems.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  isActive ? "nav__link nav__link--active" : "nav__link"
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="header__right">
            <Themetoggle />
            <button
              className="menu__button"
              onClick={() => setMobileOpen((o) => !o)}
              aria-label="Toggle menu"
              aria-expanded={mobileOpen}
            >
              {mobileOpen ? <VscClose /> : <VscGrabber />}
            </button>
          </div>
        </div>

        <nav
          className={`nav__mobile ${mobileOpen ? "nav__mobile--open" : ""}`}
          aria-label="Mobile navigation"
        >
          {navItems.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                isActive ? "nav__mobile-link nav__mobile-link--active" : "nav__mobile-link"
              }
              onClick={close}
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </header>

      <div className="br-top"></div>
      <div className="br-bottom"></div>
      <div className="br-left"></div>
      <div className="br-right"></div>
    </>
  );
};

export default Headermain;
